



































import { Component, Vue } from "vue-property-decorator";

@Component({
  props: ["IsLoading", "Id"]
})
export default class Spinners extends Vue {}
